export interface SyncDateWindowConstructor {
  startDate: Nullable<Date>
  endDate: Nullable<Date> // null = "Now" (no fixed end date)
}

export class SyncDateWindow {
  readonly startDate: Nullable<Date>
  readonly endDate: Nullable<Date>

  constructor(data: SyncDateWindowConstructor) {
    this.startDate = data.startDate
    this.endDate = data.endDate
  }
}
